import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("ellipse", {
      cx: "100",
      cy: "120",
      rx: "78",
      ry: "40"
    }, null, -1),
    _createElementVNode("ellipse", {
      cx: "100",
      cy: "116",
      fill: "var(--mc-avatar)",
      opacity: ".15",
      rx: "64",
      ry: "30"
    }, null, -1),
    _createElementVNode("ellipse", {
      cx: "100",
      cy: "112",
      rx: "48",
      ry: "22"
    }, null, -1)
  ]))]))
}
export default { render: render }